<section class="leader">
    <div class="content">
        <div class="text">
            <h2>Assine nosso boletim</h2>
            <p>Fique por dentro de tudo o que está rolando no Dia de Doar!</p>
        </div>
        <!-- <form (ngSubmit)="onSubmit()">
            <input type="email" placeholder="Digite seu e-mail" required formControlName="email">
            <button type="submit">Assinar</button>
        </form> -->

        <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
            <input type="email" placeholder="Digite seu e-mail" formControlName="email" required />
            <button type="submit">Assinar</button>
        </form>
    </div>

    <img class="background-image" src="assets/hero/stamp-yellow.svg" alt="">
    <img class="image" src="assets/mascotes/personagemAmarelo.svg" alt="Mascote Amarelo - Dia de doar">
</section>